/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_NoteInputs */

const en_us2_profile_editors_pain_note = /** @type {(inputs: Profile_Editors_Pain_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the pain like?`)
};

const pt_br2_profile_editors_pain_note = /** @type {(inputs: Profile_Editors_Pain_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como é a dor?`)
};

const es_419_profile_editors_pain_note = /** @type {(inputs: Profile_Editors_Pain_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo es el dolor?`)
};

const pt_pt2_profile_editors_pain_note = /** @type {(inputs: Profile_Editors_Pain_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como é a dor?`)
};

const fr_fr2_profile_editors_pain_note = /** @type {(inputs: Profile_Editors_Pain_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est quel genre de douleur ?`)
};

const de_de2_profile_editors_pain_note = /** @type {(inputs: Profile_Editors_Pain_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie fühlt sich der Schmerz an?`)
};

const it_it2_profile_editors_pain_note = /** @type {(inputs: Profile_Editors_Pain_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com'è il dolore?`)
};

/**
* | output |
* | --- |
* | "What is the pain like?" |
*
* @param {Profile_Editors_Pain_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_note = /** @type {((inputs?: Profile_Editors_Pain_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_note(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_note(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_note(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_note(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_note(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_note(inputs)
	return en_us2_profile_editors_pain_note(inputs)
});
export { profile_editors_pain_note as "profile-editors.pain_note" }